import { DialogTitle,IconButton } from '@mui/material';
import { ReactNode } from 'react';
import { MdClose } from 'react-icons/md';

interface DialogCustomTitleProps {
    children:ReactNode;
    onClose:()=>void;
    handleClickFunc?:()=>void;
}


export const DialogCustomTitle = (props:DialogCustomTitleProps) => {
    const { children, onClose, handleClickFunc ,...other } = props;
  return (
    (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
        <div className={"flex flex-row justify-between items-center"}>
          {children}
          {onClose ? (
            <IconButton
              aria-label="close"
              onClick={() => {
                onClose();
                handleClickFunc &&  handleClickFunc() ;
              }}
            >
              <MdClose />
            </IconButton>
          ) : null}
        </div>
      </DialogTitle>
    )
  )
}
